import { Reducer } from 'redux';

// Types
import { FareTaxState, FareTaxTypes } from './types';

const INITIAL_STATE: FareTaxState = {
  fareTaxList: [],
  fareTaxIntegratorList: [],
  fareTaxData: null,
  fareTaxIntegratorData: null,
  totalCount: 0,
  loading: false,
  error: false,
};

const reducer: Reducer<FareTaxState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST FARE TAX
    case FareTaxTypes.LIST_FARE_TAX_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        fareTaxList: INITIAL_STATE.fareTaxList,
      };
    case FareTaxTypes.LIST_FARE_TAX_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        fareTaxList: action.payload.fareTaxList,
        totalCount: action.payload.totalCount,
      };
    case FareTaxTypes.LIST_FARE_TAX_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        fareTaxList: INITIAL_STATE.fareTaxList,
      };

    // CASES LIST FARE TAX INTEGRATOR
    case FareTaxTypes.LIST_FARE_TAX_INTEGRATOR_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        fareTaxIntegratorList: INITIAL_STATE.fareTaxIntegratorList,
      };
    case FareTaxTypes.LIST_FARE_TAX_INTEGRATOR_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        fareTaxIntegratorList: action.payload.fareTaxIntegratorList,
        totalCount: action.payload.totalCount,
      };
    case FareTaxTypes.LIST_FARE_TAX_INTEGRATOR_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        fareTaxIntegratorList: INITIAL_STATE.fareTaxIntegratorList,
      };

    // CASES GET FARE TAX
    case FareTaxTypes.GET_FARE_TAX_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        fareTaxData: INITIAL_STATE.fareTaxData,
      };
    case FareTaxTypes.GET_FARE_TAX_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        fareTaxData: action.payload.fareTaxData,
      };
    case FareTaxTypes.GET_FARE_TAX_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        fareTaxData: INITIAL_STATE.fareTaxData,
      };

    // CASES GET FARE TAX INTEGRATOR
    case FareTaxTypes.GET_FARE_TAX_INTEGRATOR_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        fareTaxIntegratorData: INITIAL_STATE.fareTaxIntegratorData,
      };
    case FareTaxTypes.GET_FARE_TAX_INTEGRATOR_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        fareTaxIntegratorData: action.payload.fareTaxIntegratorData,
      };
    case FareTaxTypes.GET_FARE_TAX_INTEGRATOR_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        fareTaxIntegratorData: INITIAL_STATE.fareTaxIntegratorData,
      };

    // CASES FILTER FARE TAX
    case FareTaxTypes.FILTER_FARE_TAX_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        fareTaxList: INITIAL_STATE.fareTaxList,
      };
    case FareTaxTypes.FILTER_FARE_TAX_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        fareTaxList: action.payload.fareTaxList,
      };
    case FareTaxTypes.FILTER_FARE_TAX_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        fareTaxList: INITIAL_STATE.fareTaxList,
      };

    // CASES CREATE FARE TAX
    case FareTaxTypes.CREATE_FARE_TAX_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        fareTaxData: INITIAL_STATE.fareTaxData,
      };
    case FareTaxTypes.CREATE_FARE_TAX_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        fareTaxData: action.payload.fareTaxData,
      };
    case FareTaxTypes.CREATE_FARE_TAX_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        fareTaxData: INITIAL_STATE.fareTaxData,
      };

    // CASES CREATE FARE TAX INTEGRATOR
    case FareTaxTypes.CREATE_FARE_TAX_INTEGRATOR_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        fareTaxIntegratorData: INITIAL_STATE.fareTaxIntegratorData,
      };
    case FareTaxTypes.CREATE_FARE_TAX_INTEGRATOR_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        fareTaxIntegratorData: action.payload.fareTaxIntegratorData,
      };
    case FareTaxTypes.CREATE_FARE_TAX_INTEGRATOR_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        fareTaxIntegratorData: INITIAL_STATE.fareTaxIntegratorData,
      };

    // CASES UPDATE FARE TAX
    case FareTaxTypes.UPDATE_FARE_TAX_REQUEST:
      return { ...state, loading: true, error: false };

    case FareTaxTypes.UPDATE_FARE_TAX_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        fareTaxData: action.payload.fareTaxData,
      };
    case FareTaxTypes.UPDATE_FARE_TAX_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES UPDATE FARE TAX INTEGRATOR
    case FareTaxTypes.UPDATE_FARE_TAX_INTEGRATOR_REQUEST:
      return { ...state, loading: true, error: false };

    case FareTaxTypes.UPDATE_FARE_TAX_INTEGRATOR_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        fareTaxIntegratorData: action.payload.fareTaxIntegratorData,
      };
    case FareTaxTypes.UPDATE_FARE_TAX_INTEGRATOR_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES DELETE FARE TAX
    case FareTaxTypes.DELETE_FARE_TAX_REQUEST:
      return { ...state, loading: true, error: false };

    case FareTaxTypes.DELETE_FARE_TAX_SUCCESS:
      return { ...state, loading: false, error: false };

    case FareTaxTypes.DELETE_FARE_TAX_FAILURE:
      return { ...state, loading: false, error: false };

    // CASES DELETE FARE TAX INTEGRATOR
    case FareTaxTypes.DELETE_FARE_TAX_INTEGRATOR_REQUEST:
      return { ...state, loading: true, error: false };

    case FareTaxTypes.DELETE_FARE_TAX_INTEGRATOR_SUCCESS:
      return { ...state, loading: false, error: false };

    case FareTaxTypes.DELETE_FARE_TAX_INTEGRATOR_FAILURE:
      return { ...state, loading: false, error: false };

    default:
      return state;
  }
};

export default reducer;
